// styles
import { Box, Link } from '@mui/material';
import { ReactComponent as Discord } from 'core/assets/svg/footer/discord.svg';
import { ReactComponent as Email } from 'core/assets/svg/footer/email.svg';

// constants
// assets
import { ReactComponent as Instagram } from 'core/assets/svg/footer/instagram.svg';
import { ReactComponent as Twitter } from 'core/assets/svg/footer/twitter.svg';
import { ReactComponent as Youtube } from 'core/assets/svg/footer/youtube.svg';
import BaseButton from 'core/components/button/BaseButton';

// redux
import BaseTypography from 'core/components/typography/BaseTypography';
import { apiDocumentationLink } from 'core/constants/constants';
import { footerNavigationLinksCardStyles } from 'core/layouts/components/footer-navigation-links-card/FooterNavigationLinksCardStyles';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import {
	DISCORD,
	EMAIL,
	INSTAGRAM,
	PRIVACY_POLICY,
	TERMS_AND_CONDITIONS,
	TWITTER,
	YOUTUBE,
} from 'core/navigation/Routes';
import * as React from 'react';

export default function FooterNavigationLinksCard() {
	return (
		<Box sx={[reusableStyles.flexCol, { alignItems: 'start', gap: '16px' }]}>
			<BaseTypography variant="b2_caption" color="colors.light5">
				Get in touch
			</BaseTypography>
			<Box sx={[reusableStyles.flexRow, { width: '100%', justifyContent: 'space-between' }]}>
				<Link
					href={`mailto:${EMAIL}`}
					target="_blank"
					sx={[footerNavigationLinksCardStyles.footerTextButton]}
				>
					<Email />
				</Link>

				<Link
					href={DISCORD}
					target="_blank"
					sx={[footerNavigationLinksCardStyles.footerTextButton]}
				>
					<Discord />
				</Link>

				<Link
					href={TWITTER}
					target="_blank"
					sx={[footerNavigationLinksCardStyles.footerTextButton]}
				>
					<Twitter />
				</Link>

				<Link
					href={YOUTUBE}
					target="_blank"
					sx={[footerNavigationLinksCardStyles.footerTextButton]}
				>
					<Youtube />
				</Link>

				<Link
					href={INSTAGRAM}
					target="_blank"
					sx={[footerNavigationLinksCardStyles.footerTextButton]}
				>
					<Instagram />
				</Link>
			</Box>

			<Box id="footer-section-divider" sx={footerNavigationLinksCardStyles.footerDivider} />

			<Box sx={[reusableStyles.flexRow, { width: '100%', justifyContent: 'space-between' }]}>
				<BaseButton
					id="terms-and-conditions-button"
					styles={footerNavigationLinksCardStyles.footerTextButton}
					href={TERMS_AND_CONDITIONS}
					target="_blank"
				>
					<BaseTypography variant="b2_caption" styles={footerNavigationLinksCardStyles.footerText}>
						T&C
					</BaseTypography>
				</BaseButton>

				<BaseButton
					id="privacy-policy-button"
					styles={footerNavigationLinksCardStyles.footerTextButton}
					href={PRIVACY_POLICY}
					target="_blank"
				>
					<BaseTypography variant="b2_caption" styles={footerNavigationLinksCardStyles.footerText}>
						Privacy
					</BaseTypography>
				</BaseButton>

				<Link
					href={apiDocumentationLink}
					target="_blank"
					sx={[footerNavigationLinksCardStyles.footerTextButton]}
				>
					<BaseTypography variant="b2_caption" styles={footerNavigationLinksCardStyles.footerText}>
						API
					</BaseTypography>
				</Link>
			</Box>
		</Box>
	);
}
